export default () => {
  return `#import <UIKit/UIKit.h>

NS_ASSUME_NONNULL_BEGIN

@interface CheckoutViewController : UIViewController

@end

NS_ASSUME_NONNULL_END`;
};
